import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENTS_SUMMARY: MijnRoute = {
    path: 'overzicht',
    navigationEvent: 'toOverboekenOverzicht',
    regex: /^\/overboeken\/overzicht$/,
    webcomponent: 'mijn-overboeken-webcomponent',
    internalPath: '/overzicht'
};
